<template>
<div>
    <base-header v-once pageName="자녀수정" :popup="true"></base-header>
    
    <section id="wrap">
        <dl class="child-add">
            <dt>성별</dt>
            <dd class="flex-between">
                <span class="radioBtn">
                    <input type="radio" v-model.trim="childInfo.chlngndr" id="male" value="M" @keyup="checkVal">
                    <label for="male">남자</label>
                </span>
                <span class="radioBtn">
                    <input type="radio" v-model.trim="childInfo.chlngndr" id="female" value="F" @keyup="checkVal">
                    <label for="female">여자</label>
                </span>
            </dd>
            <dt>생년월일</dt>
            <dd>
                <input type="tel" ref= "chlnbdt" id="chlnbdt"  :value="childInfo.chlnbdt" v-on:input="checkText($event)" @keyup="checkVal" placeholder="8자리를 입력해주세요. (예 : 201500101)">
                <input type="text" v-model.trim="childInfo.age" disabled>
            </dd>
            <dt>이름</dt>
            <dd><input type="text" ref= "chlnnam" id="chlnnam" :value="childInfo.chlnnam" v-on:input="checkText($event)" placeholder="자녀명을 입력해주세요."></dd>
        </dl>
    </section>  
    <div class="btnWrap">
        <button type="button" class="red" @click="saveChild()">수정</button>
    </div>  
</div>
</template>

<script>
export default {
    data() {
        return {
            childInfo: {
                sqno: 0, // 키
                chlnnam: "", // 자녀명
                chlnbdt: "", // 자녀생년월일
                chlngndr: "", // 자녀성별
                age: "", // 자녀나이
            },
        };
    },
    methods: {
        checkText: function (e) {
            if (e.target.id == 'chlnbdt') {
                if (e.target.value.length > 8) {
                    e.target.value = e.target.value.substr(0, 8);
                } else {
                    this.childInfo.chlnbdt = e.target.value;
                }
            }
            if (e.target.id == 'chlnnam') {
                if (e.target.value.length > 10) {
                    e.target.value = e.target.value.substr(0, 10);
                } else {
                    this.childInfo.chlnnam = e.target.value;
                }
            }
        },
        checkVal: function (e) {
            if (e.target.id == 'male' || e.target.id == 'female') {
                this.$refs.chlnbdt.focus();
            } else if (e.target.id == 'chlnbdt') {
                if (!isNaN(e.target.value) && e.target.value.length == 8) {
                    this.childInfo.age = this.$utils.calendar.getAge2(e.target.value);
                    this.$refs.chlnnam.focus();
                }
            }
        },
        validate() { // 유효성 체크     
            if (this.$utils.stringUtil.isNull(this.childInfo.chlngndr)) {
                alert("자녀성별을 선택해주세요.");
                return false;
            }
            if (!this.$utils.stringUtil.isNull(this.childInfo.chlnbdt)) {
                if (this.childInfo.chlnbdt.length < 8) {
                    alert("자녀생년월일을 입력해주세요.");
                    this.$refs.chlnbdt.focus();
                    return false;
                }
                if (!this.$utils.calendar.isBirthday(this.childInfo.chlnbdt)) {
                    alert("자녀생년월일을 정확히 입력해주세요.");
                    this.$refs.chlnbdt.focus();
                    return false;
                }
            }
            if (this.$utils.stringUtil.isNull(this.childInfo.chlnnam)) {
                alert("자녀명을 입력해주세요.");
                this.$refs.chlnnam.focus();
                return false;
            }
            return true;
        },
        saveChild: function () {
            var validate = this.validate();
            if (!validate) {
                return;
            }
            
            alert('고객정보 수정 시 약 1분 정도의 시간이 소요됩니다.\n처리에 문제가 있는 경우 잠시 후에 다시 이용해 주세요.');

            var child = {
                name: "modify-children-result",
                data: this.childInfo
            };
            console.log("ModifyChildren.vue child", child);
            this.$utils.nativeIf.outbound.sendChildData(child);
        }
    },
    mounted: function () { //  인스턴스가 마운트 된 직후
        const parent = this.$store.getters.parent;
        const child = parent.data.child;
        this.childInfo.sqno = child.sqno;
        this.childInfo.chlnnam = child.chlnnam;
        this.childInfo.chlnbdt = child.chlnbdt;
        this.childInfo.chlngndr = child.chlngndr;
        if (this.childInfo.chlnbdt) {
            this.childInfo.age = this.$utils.calendar.getAge2(this.childInfo.chlnbdt);
        }
    }
};
</script>
